module.exports = __webpack_public_path__ + "img/clock.6251aca6.svg";